import React from 'react';
import { ReactSVG } from 'react-svg';
import Svg from 'assets/images/payment/jcb.svg';

type Props = {
  className?: string;
};

export const JCB = ({ className }: Props) => {
  return (
    <ReactSVG
      src={Svg}
      className={className}
    />
  );
};
